<template>
  <div class="admin-room-fee-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('adminRoomFee.page.title')"
      :subtitle="adminRoomFeeInfo.roomName || $t('adminRoomFee.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-search" @click="_queryAdminRoomFeeMethod">
          {{ $t('common.search') }}
        </el-button>
        <el-button icon="el-icon-refresh-left" @click="_resetAdminRoomFeeMethod">
          {{ $t('common.reset') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="admin-room-fee-layout">
      <!-- 左侧房屋树 -->
      <div class="ds-panel ds-panel--tree">
        <community-room-tree ref="communityTree" @select-room="handleSelectRoom" />
      </div>

      <!-- 右侧房屋费用详情 -->
      <div class="admin-room-fee-main">
        <div class="ds-panel">
          <!-- (2) SearchPanel -->
          <ds-search-panel class="ds-search-panel--flush">
            <el-row :gutter="16">
              <el-col :xs="24" :sm="12" :md="8" :lg="6">
                <el-input v-model="adminRoomFeeInfo.condition.roomNum" clearable class="w-full"
                  :placeholder="$t('adminRoomFee.roomNumPlaceholder')" @blur="listRoomInAdminRoomFee" />
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="6">
                <el-input v-model="adminRoomFeeInfo.condition.ownerName" clearable class="w-full"
                  :placeholder="$t('adminRoomFee.ownerNamePlaceholder')" @input="_inputRoomByOwner" />
              </el-col>
            </el-row>
          </ds-search-panel>

          <!-- Tab 联动面板 -->
          <el-tabs v-model="adminRoomFeeInfo._currentTab" class="ds-tabs" @tab-click="changeTab(adminRoomFeeInfo._currentTab)">
            <el-tab-pane label="房屋费用" name="aRoomDetailRoomFee" />
            <el-tab-pane v-if="adminRoomFeeInfo.ownerId" label="缴费历史" name="aRoomDetailHisFee" />
            <el-tab-pane v-if="adminRoomFeeInfo.ownerId" label="房屋" name="aRoomDetailRoom" />
            <el-tab-pane v-if="adminRoomFeeInfo.ownerId" label="业主" name="aRoomDetailOwner" />
            <el-tab-pane label="催缴" name="aRoomFeeCallable" />
            <el-tab-pane label="收据" name="aRoomDetailReceipt" />
            <el-tab-pane label="抄表记录" name="aRoomDetailMeterWaterLog" />
            <el-tab-pane v-if="adminRoomFeeInfo.ownerId" label="预存账户" name="aOwnerDetailAccount" />
            <el-tab-pane v-if="adminRoomFeeInfo.ownerId" label="预存补打" name="aOwnerDetailAcctReceipt" />
            <el-tab-pane label="押金" name="aRefundDeposit" />
          </el-tabs>

          <div class="ds-tab-body">
            <component :is="adminRoomFeeInfo._currentTab" :ref="adminRoomFeeInfo._currentTab"
              :room-id="adminRoomFeeInfo.roomId" :owner-id="adminRoomFeeInfo.ownerId" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommunityRoomTree from '@/components/fee/communityRoomTree'
import ARoomDetailRoomFee from '@/components/fee/aRoomDetailRoomFee'
import ARoomDetailHisFee from '@/components/fee/aRoomDetailHisFee'
import ARoomDetailRoom from '@/components/fee/aRoomDetailRoom'
import ARoomDetailOwner from '@/components/fee/aRoomDetailOwner'
import ARoomDetailMeterWaterLog from '@/components/fee/aRoomDetailMeterWaterLog'
import ARoomDetailReceipt from '@/components/fee/aRoomDetailReceipt'
import AOwnerDetailAccount from '@/components/fee/aOwnerDetailAccount'
import AOwnerDetailAcctReceipt from '@/components/fee/aOwnerDetailAcctReceipt'
import ARoomFeeCallable from '@/components/fee/aRoomFeeCallable'
import ARefundDeposit from '@/components/fee/aRefundDeposit'

import { queryAdminRoom } from '@/api/fee/adminRoomFeeApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsSearchPanel from '@/components/ds/ds-search-panel.vue'

export default {
  name: 'AdminRoomFeeList',
  components: {
    CommunityRoomTree,
    ARoomDetailRoomFee,
    ARoomDetailHisFee,
    ARoomDetailRoom,
    ARoomDetailOwner,
    ARoomDetailMeterWaterLog,
    ARoomDetailReceipt,
    AOwnerDetailAccount,
    AOwnerDetailAcctReceipt,
    ARoomFeeCallable,
    ARefundDeposit,
    DsPageHeader,
    DsSearchPanel
  },
  data() {
    return {
      adminRoomFeeInfo: {
        roomName: '',
        roomId: '',
        ownerId: '',
        ownerName: '',
        roomType: '',
        _currentTab: 'aRoomDetailRoomFee',
        condition: {
          roomNum: '',
          ownerName: ''
        }
      }
    }
  },
  created() {
    //this.$refs.communityTree.initCommunityRoomTree('adminRoomFee')
  },
  methods: {
    handleSelectRoom(room) {
      this.adminRoomFeeInfo.ownerName = ''
      this.adminRoomFeeInfo.ownerId = ''
      this.adminRoomFeeInfo.roomId = room.roomId
      this.adminRoomFeeInfo.roomName = room.roomName
      this.adminRoomFeeInfo.condition.ownerName = ''
      this.adminRoomFeeInfo.condition.roomNum = ''
      this.listRoomInAdminRoomFee()
    },
    async listRoomInAdminRoomFee() {
      const param = {
        page: 1,
        row: 1,
        roomId: this.adminRoomFeeInfo.roomId
      }

      if (this.adminRoomFeeInfo.condition.roomNum) {
        param.flag = '1'
        param.roomNum = this.adminRoomFeeInfo.condition.roomNum
        param.roomId = ''
        this.adminRoomFeeInfo.roomName = ''
        this.adminRoomFeeInfo.ownerName = ''
        this.adminRoomFeeInfo.ownerId = ''
        this.adminRoomFeeInfo.roomId = ''
      }

      const res = await queryAdminRoom(param)
      const room = res.data[0]
      Object.assign(this.adminRoomFeeInfo, room)
      this.changeTab(this.adminRoomFeeInfo._currentTab)
    },
    _queryAdminRoomFeeMethod() {
      this.listRoomInAdminRoomFee()
    },
    _resetAdminRoomFeeMethod() {
      this.adminRoomFeeInfo.roomNum = ''
      this.adminRoomFeeInfo.ownerName = ''
      this.adminRoomFeeInfo.ownerId = ''
      this.adminRoomFeeInfo.condition.ownerName = ''
      this.adminRoomFeeInfo.condition.roomNum = ''
      this.changeTab(this.adminRoomFeeInfo._currentTab)
    },
    changeTab(tab) {
      this.adminRoomFeeInfo._currentTab = tab
      if (!this.adminRoomFeeInfo.roomId) {
        return
      }
      setTimeout(() => {
        const ref = this.$refs[this.adminRoomFeeInfo._currentTab]
        if (ref && ref.open) {
          ref.open(this.adminRoomFeeInfo.ownerId, this.adminRoomFeeInfo.roomId)
        }
      }, 500)
    },
    _inputRoomByOwner() {
      // Implement input room by owner logic
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-room-fee-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 左侧房屋树 + 右侧详情 */
.admin-room-fee-layout {
  display: flex;
  gap: var(--ds-spacing-md);
  align-items: flex-start;
}

.admin-room-fee-main {
  flex: 1 1 auto;
  min-width: 0;
}

/* 房屋树面板 */
.ds-panel--tree {
  width: 280px;
  flex-shrink: 0;
  overflow: auto;
  max-height: calc(100vh - 220px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
}

/* 面板内嵌筛选条：去掉外边距与阴影，避免双层卡片 */
.ds-search-panel--flush {
  margin-bottom: 0;
  border: none;
  border-bottom: 1px solid var(--ds-gray-200);
  border-radius: 0;
  box-shadow: none;
}

/* Tab 区域 */
.ds-tabs {
  padding: 0 var(--ds-spacing-lg);

  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
}

/* Tab 内容区 */
.ds-tab-body {
  padding: var(--ds-spacing-md) var(--ds-spacing-lg) var(--ds-spacing-lg);
}
</style>
